import React from 'react'
import { colors } from '@retailer-platform/shared-components'

interface InsightsPortalKpiOverviewTrendTooltipProps<T> {
  formatterContext: T
  header: (context: T) => JSX.Element
  body: (context: T) => JSX.Element
}

export const InsightsPortalKpiOverviewTrendTooltip = <T,>({
  formatterContext,
  header,
  body,
}: InsightsPortalKpiOverviewTrendTooltipProps<T>) => (
  <div>
    <div>{header(formatterContext)}</div>
    <hr style={{ borderTop: `1px solid ${colors.GRAYSCALE.X30}` }} />
    <div>{body(formatterContext)}</div>
  </div>
)
